<template>
    <div>
        <breadCrumb 
            :icon="'fa-gifts'"
            :category="$t(`sideNav.navSalonReport`)"
            subCategory="Roster"
            :subSubCategory="''">
        </breadCrumb>

        <div v-if="!addToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add Leave" @click="addData(null)">
                <span class="fal fa-plus mr-2"></span>
                <span>Add Leave</span>
            </button>
        </div>

        <div v-if="!addToggle">
            <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
                <li class="nav-item" v-for="t in tabs" :key="t.id">
                    <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
                </li>
            </ul>

            <div v-if="!showSpinner" class="px-3 px-sm-5 py-4">
                <div class="tab-content">
                    <dataList
                        ref="dataList"
                        :outlets="outlets"
                        class="tab-pane active"
                        :selectedTab="selectedTab"
                        :staffs="staffs"
                        @onOutletChange="onOutletChange"
                        @addData="addData"
                        @editData="editData">
                    </dataList>

                    <!-- :class="{'active': selectedTab == 'list' }" -->
                </div>
            </div>
        </div>

        <dataForm
            ref="dataForm"
            :leaveTypes="leaveTypes"
            :staffs="staffs"
            :outlets="outlets"
            @onModalClose="onDataFormClose">
        </dataForm>

        <div v-if="showSpinner" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import dataForm from './Form'
import dataList from './List'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'menuReportRoster',
    components:{
        BreadCrumb,
        dataForm, 
        dataList, 
    },
    data(){
        let tabs = [
            {"id": "calendar", "text": "Calendar"},
            // {"id": "staff", "text": "Staff"},
            {"id": "list", "text": "List"}
        ]
        let selectedtab = tabs[0].id
        // selectedtab = tabs[1].id
        
        return{
            tabs: tabs,
            showSpinner: false,

            addToggle: false,
            selectedTab: selectedtab,

            memberLists: [], 
            outlets:[],
            staffs: [],
            leaveTypes: [],
        }
    },
    watch:{
        selectedTab(value){
            if(value == "active" || value == "hidden"){
                this.$refs.memberList.filterMemberByView(value);
            }
        },
    },
    methods:{
        loadStaff() {
            this.showSpinner = true

            const url = "https://staff.tunai.io/business/staff/"

            this.$axios({
                method: 'get',
                url: url,
                headers: { token: this.$util.getSessionToken() }
            })
            .then((response) => {
                this.staffs = []

                for(let staff of response.data['staffs']) {
                    this.staffs.push(staff)
                }
            })
            .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                }
            })
            .finally(() => {
                if(this.leaveTypes.length > 0 && this.staffs.length > 0) {
                    this.showSpinner = false
                }
            })
        },

        loadLeaveType() {
            this.showSpinner = true
            
            const url = "https://staff.tunai.io/business/staff/leaves/type"

            this.$axios({
                method: 'get',
                url: url,
                headers: { token: this.$util.getSessionToken() }
            })
            .then((response) => {
                this.leaveTypes = []

                for(let type of response.data['type']) {
                    this.leaveTypes.push(type)
                }
            })
            .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                }
            })
            .finally(() => {
                if(this.leaveTypes.length > 0 && this.staffs.length > 0) {
                    this.showSpinner = false
                }
            })
        },

        onOutletChange(val) {
            this.filterOutlet = val
        },

        addData(date, staffID) {
            this.$refs.dataForm.show(this.filterOutlet, null, date, staffID)
        },
        editData(item) {
            let staff = this.staffs.find(k => k['staffID'] === item['staffID'])
            let outlet = this.outlets.find(k => k['id'] === staff['outletID'])
            this.$refs.dataForm.show(outlet, item)
        },
        onDataFormClose() {
            this.$refs.dataList.loadData()
        },
    },
    mounted(){
        this.outlets = JSON.parse(this.$store.state.outlets);
        this.outlets.unshift({ id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) })
        this.filterOutlet = this.outlets[0];

        this.loadStaff()
        this.loadLeaveType()
    },
}
</script>